<div class="interest-card" tabindex="0">
  <ten-card-ribbon
    *ngIf="card?.followButton?.product?.category"
    [ribbonData]="getRibbon(card?.followButton?.product?.category)"
    class="interest-card-ribbon"
  ></ten-card-ribbon>
  <div class="interest-card__image" [ngStyle]="{ 'background-image': 'url(' + image + ')' }">
    <img *ngIf="card?.imageUrl" [src]="card.imageUrl" alt="Image of the interest" />
  </div>
  <div class="interest-card__body">
    <p class="interest-card__body--name">{{ card?.name }}</p>
    <ten-follow-button [followButtonData]="card.followButton" class="interest-card__body--button"></ten-follow-button>
  </div>
</div>
